<script setup lang="ts">
import type { BlogT } from '~/schema/types'

const props = defineProps<{
  blogs?: BlogT[]
  search?: string
  path?: string
  page?: number
  meta?: {
    page: number
    limit: number
    total: number
    totalPages: number
  }
}>()

const router = useRouter()
const active = useState('blog-state')

const generateRoute = (page: number) => {
  let parentPath = props.path?.length ? props.path : '/blog'
  // Replace /page/{number} with /page/{page}
  parentPath = parentPath.replace(/\/page\/\d+$/, `/page/${page}`)
  // If no /page/{number} present, append /page/{page}
  if (!/\/page\/\d+$/.test(parentPath)) {
    parentPath += `/page/${page}`
  }
  return parentPath + (props.search ? `?search=${props.search}` : '')
}

const page = computed({
  get: () => props.page ?? 1,
  set: (value: number) => {
    router.push({
      path: generateRoute(value)
    })
  }
})
</script>
<template>
  <UiContainer>
    <p
      v-if="blogs?.length"
      class="text-lg lg:text-xl font-inter font-semibold lg:py-4 mb-3"
    >
      Artikel {{ page === 1 ? props.search || 'Terbaru' : `Halaman ${page}` }}
    </p>
    <div class="grid lg:grid-cols-3 gap-3 lg:gap-x-5 lg:gap-y-7">
      <UiCardBlog
        v-for="(blog, index) in blogs ?? []"
        :key="blog.slug + index"
        :blog="blog"
        :class="{ active: active === blog.slug }"
        @mouseenter="active = blog.slug"
      />
    </div>
    <UiPagination
      v-if="blogs?.length"
      v-model:page="page"
      :total="props.meta?.total ?? 0"
      :limit="props.meta?.limit ?? 10"
      class="text-center mt-5"
    >
      <template #item="{ value }">
        <NuxtLink
          :to="generateRoute(value)"
          class="absolute inset-0 flex items-center justify-center"
        >
          {{ value }}
        </NuxtLink>
      </template>
    </UiPagination>
  </UiContainer>
</template>

<style>
.active .img {
  view-transition-name: image;
}

.active .title {
  view-transition-name: title;
}

.active .category {
  view-transition-name: category;
}

.active .author {
  view-transition-name: author;
}
</style>
